import { isAfter, isBefore } from 'date-fns';
import type { QueryShipmentsForShipperArgs, Shipment } from 'graphql-models';

export const filterOn = (
  list: Shipment[],
  filter?: QueryShipmentsForShipperArgs['filter'],
) => {
  const { search, fromDate, toDate, consigneeId, shipmentType, ...others } =
    filter || {};

  return list.filter(
    ({ parcelId, updatedAt, consignee, box, ...rest }) =>
      (search
        ? parcelId?.toLocaleLowerCase().includes(search.toLocaleLowerCase())
        : true) &&
      (fromDate ? isBefore(new Date(fromDate), updatedAt) : true) &&
      (consigneeId ? consignee.id === consigneeId : true) &&
      (toDate ? isAfter(new Date(toDate), updatedAt) : true) &&
      (shipmentType && shipmentType === 'BOX' ? !!box : true) &&
      (others
        ? Object.keys(others).every(
            // @ts-expect-error no good way to force typescript to know these keys are correct
            (key) => (others[key] as string) === (rest[key] as string),
          )
        : true),
  );
};
